import React from 'react';

// Utils
import { isFeedbackSharedAnonymously } from 'Shared/utils/Reviews.utils';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';

// Hooks
import { useReview } from 'Shared/utils/hooks/use-review';

// Components
import AnonymousPeerReviewAlert from '../../ThreeSixtyReviewPartials/AnonymousPeerReviewAlert/AnonymousPeerReviewAlert';

// Styles
import './IndividualResposnesAlert.scss';

type Props = {
  review;
  isSelfPeerReview?: boolean;
};

const IndividualResposnesAlert = ({ review, isSelfPeerReview }: Props) => {
  const isPeerReviewSharedAnonymously = isFeedbackSharedAnonymously({ review });

  const reviewSlug = ReviewsHelpers.getSlug(review);

  const { isPerformanceReview, isSelf360 } = useReview({ slug: reviewSlug });

  if (isSelf360) return null;
  if (isPerformanceReview) return null;

  const baseClassName = 'IndividualResposnesAlert';

  const text = isPeerReviewSharedAnonymously
    ? `%receiverName% will be able to see your feedback, but we won’t include your name.`
    : `%receiverName% won’t see your specific feedback. They’ll only see a summary of the feedback provided by all contributors.`;

  if (isSelfPeerReview) return null;

  return (
    <div className={`${baseClassName}__alert`}>
      <AnonymousPeerReviewAlert review={review} text={text} />
    </div>
  );
};

export default IndividualResposnesAlert;
